export default {
  title: 'Indtægtsrapporter',
  sections: {
    new_report: 'Ny rapport',
  },
  form: {
    period: {
      label: 'Periode',
    },
  },
  buttons: {
    export: 'Eksportér',
  },
  toasts: {
    failed_to_create_report: 'Rapporten kunne ikke oprettes',
  },
};
